import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=448041dd&scoped=true&"
import script from "./resultInfo.vue?vue&type=script&lang=tsx&"
export * from "./resultInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./resultInfo.vue?vue&type=style&index=0&id=448041dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448041dd",
  null
  
)

export default component.exports